import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import { MiaPlaza } from "../../../../Reinforced.Typings";
import Log from "../../../../utils/Log";
import { sanitize } from "../../I18Next";
import { type ForNotification } from "./DerivedInterfaces";

@Component
export class Notification<T extends ForNotification<MiaPlaza.Control.Vue.Notifications.Shared.INotification>>
	extends Vue {
	@Prop({ required: true, type: Object }) from!: T;

	// At some point, before we used vue-snotify, notifications could contain arbitrary HTML. This was mostly because
	// notifications would only be created in C# code on the server so it was easier to reason about how trustworthy
	// the contents were (because we used UntrustedString there.) Now, on the client, the situation is more difficult.
	// We might get escaping of user provided content wrong, so it is slightly dangerous to allow HTML here.
	// However, we allow any HTML that sanitize-html would let go through (so no script blocks but links to the wrong
	// place e.g.). This is temporary measure not to break legacy text resources. See
	// https://dev.miaplaza.com/miaplaza/website/issues/11291.
	escape(message: string): string {
		// The regex checks for any HTML tags except <br />. Some text resources contain line breaks that are replaced by
		// harmless <br> tags on the server, so we don't want to log those here.
		// The (?!br\s*\/?>) is a negative lookahead that ensures the tag is not <br>
		// (with optional whitespace and optional closing slash).
		const nonBreakTagRegex = /<(?!br\s*\/?>)/i;

		if (nonBreakTagRegex.test(message)) {
			void Log.error(`Notification contained HTML. This legacy support is going to be disabled at some point so you need to adapt the text resource. The text was ${message}. If the HTML came from a user then this is a slight problem as it means that a developer managed to call into the notification framework without knowing that it is not completely safe. Please fix #11291 very soon.`);
		}
		return sanitize(message);
	}
}

export default toNative(Notification);
